import * as React from "react";
import { DateField, TextField, EditButton, TextInput, SelectInput, FunctionField } from "react-admin";
import { StatusEnum } from "src/common/enum";
import { Datagrid, IfCanAccess, List } from "src/enterprise/ra-rbac";

const listFilters = [
<TextInput source="search" label="Search" alwaysOn />,
<SelectInput source="Status" choices={StatusEnum} />


];
export const GroupList = (props) => (
  <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="email" />7
      <FunctionField label="Status" render={record => StatusEnum.find(x => x.id === record.status)?.name}/>      <DateField source="created_at" label="Created At" />
      <IfCanAccess action="edit">
        <EditButton />
      </IfCanAccess>
    </Datagrid>
  </List>
);
